<div class="Cstm_wrapper_area">
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <app-header></app-header>
    <main class="main-body-container">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>